var CookieService = /** @class */ (function () {
    function CookieService() {
    }
    CookieService.getInstance = function () {
        if (!CookieService.instance) {
            CookieService.instance = new CookieService();
        }
        return CookieService.instance;
    };
    CookieService.prototype.createCookie = function (options) {
        var cookie = {
            key: options.key ? options.key : null,
            value: options.value ? options.value : null,
            hostOnly: true,
            secure: options.secure ? options.secure : false,
            path: options.path ? options.path : '/',
            maxAge: options.maxAge ? options.maxAge : 2147483647,
            sameSite: options.sameSite ? options.sameSite : 'Strict'
        };
        var cookieArray = [
            (cookie.key.toString() + '=' + JSON.stringify(cookie.value)),
            (cookie.secure ? 'secure' : ''),
            ('path=' + cookie.path.toString()),
            ('max-age=' + cookie.maxAge.toString()),
            ('sameSite=' + cookie.sameSite.toString())
        ];
        document.cookie = cookieArray.join(';');
    };
    CookieService.prototype.deleteCookie = function (key) {
        this.createCookie({
            key: key,
            value: [],
            hostOnly: true,
            maxAge: 1
        });
    };
    CookieService.prototype.readCookie = function (key) {
        var re = new RegExp('[; ]' + key + '=([^\\s;]*)');
        var sMatch = (' ' + document.cookie).match(re);
        if (key && sMatch)
            return unescape(sMatch[1]);
        return '';
    };
    return CookieService;
}());
export default CookieService;



//////////////////
// WEBPACK FOOTER
// ./service/cookie.service.tsx
// module id = null
// module chunks = 